import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOil = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.995 2L17.655 7.66C18.7743 8.77861 19.5368 10.2041 19.8459 11.7561C20.155 13.308 19.9969 14.9168 19.3915 16.379C18.7862 17.8411 17.7608 19.0908 16.4451 19.9701C15.1294 20.8494 13.5825 21.3187 12 21.3187C10.4175 21.3187 8.8706 20.8494 7.5549 19.9701C6.23919 19.0908 5.21381 17.8411 4.60847 16.379C4.00312 14.9168 3.845 13.308 4.15411 11.7561C4.46321 10.2041 5.22566 8.77861 6.345 7.66L11.995 2Z",
		fill: "#DBE4E8",
		stroke: "#293235",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgOil);
export { ForwardRef as ReactComponent };
